<template>
  <div class="animated fadeIn">
    <basic-heading title="Instrument Definitions" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list instrument'">
      <template #gated-content>
        <instrument-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentServerTable from "@/components/lab/instrument/InstrumentServerTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "InstrumentIndex",
  components: {
    BasicHeading,
    InstrumentServerTable,
    HeaderButtonGroup,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/instrument/add",
            title: "Add instrument",
            variant: "success",
            permission: this.checkPermission("add instrument"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
